import { useLocation, useHistory } from 'react-router-dom'
import { useMemo } from 'react'

function useURLParams({ pushNewState = true }: { pushNewState?: boolean } = { pushNewState: true }) {
  const { search } = useLocation()
  const history = useHistory()

  const urlParams = useMemo(() => new URLSearchParams(search), [search])

  const setURLParams = (newParams: Record<string, string | undefined>) => {
    const currentParams = new URLSearchParams(search)

    Object.keys(newParams).forEach((key) => {
      if (newParams[key]) {
        currentParams.set(key, newParams[key] as string)
      } else {
        currentParams.delete(key)
      }
    })

    if (pushNewState) {
      history.push({ search: currentParams.toString() })
    } else {
      history.replace({ search: currentParams.toString() })
    }
  }

  return [urlParams, setURLParams] as const
}

export default useURLParams
